<template>
  <div v-if="isCategory || isRootCategory" class="py-10">
    <div class="mb-8">
      <category-header :content="headerContent" />
    </div>
    <category-list :is-dynamic="true" :categories="categoryList" />

    <div v-if="longDescription" class="container pt-8">
      <div class="row">
        <div class="col-12">
          <div class="bg-white p-6 p-lg-8 p-xl-12" v-html="longDescription" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import contentMixin from '@/mixins/contentMixin';
import CategoryList from '@/components/organisms/ShopCommerce/CategoryList';
import CategoryHeader from '@/components/organisms/ShopCommerce/CategoryHeader';

export default {
  name: 'CategoryDynamic',
  components: {
    CategoryList,
    CategoryHeader
  },
  mixins: [contentMixin],
  async fetch () {
    let baseCategoryList = [];
    if (this.isCategory) {
      this.category = await this.$repositories.category.byGuid(this.categoryListGuid, this.culture);
      baseCategoryList = await this.$repositories.category.byParentId(
        this.categoryListGuid,
        this.culture
      );
    } else if (this.isRootCategory) {
      let rootGuid = this.content?.nzSettingCatalog && this.content?.nzSettingCatalog.length ? this.content?.nzSettingCatalog[0] : 'cda730a0-252b-4828-98c4-7b2020066617';
      baseCategoryList = await this.$repositories.category.getRootByGuid(
        rootGuid,
        this.culture
      );
    }
    this.categoryList = baseCategoryList.filter(x => this.getPropertyValue(x, 'hideInNavigation') !== 'True')
    this.isLoading = false;

    // Klaviyo tracking - only fire if there are subcategories (after data is loaded)
    if (process.client && this.categoryListGuid && this.categoryList.length > 0 && !this.klaviyoTracked) {
      const categoryName = this.headline || 'Category';
      
      const subCollectionNames = this.categoryList.map(c => c.name || '');
      const subCollectionIDs = this.categoryList.map(c => c.guid || c.id || '');
      
      const eventData = {
        CollectionName: categoryName,
        SubCollectionNames: subCollectionNames,
        SubCollectionIDs: subCollectionIDs,
        URL: typeof window !== 'undefined' ? window.location.pathname : null
      };
      
      this.$repositories.klaviyo.track('Viewed Category', eventData, this.$store.getters['user/user/getUser']?.email || null, null)
        .then(() => {
          this.klaviyoTracked = true
        })
        .catch(e => {
          // Silent fail - don't break the page if Klaviyo tracking fails
        });
    }
  },
  data () {
    return {
      category: null,
      categoryList: [],
      isLoading: true,
      klaviyoTracked: false
    }
  },
  computed: {
    culture () {
      return this.$store.getters['site/getCurrentCulture'];
    },
    headline () {
      return this.category?.name ?? this.$store.getters['content/content/getContent']?.meta?.title;
    },
    template () {
      return this.$store.getters['content/content/getContent']?.meta?.template;
    },
    categoryListGuid () {
      return this.$store.getters['content/content/getContent']?.meta?.id;
    },
    isCategory () {
      let type = this.$store.getters['content/content/getContent']?.meta?.type;
      return type === 'ContentCategory';
    },
    isRootCategory () {
      let type = this.$store.getters['content/content/getContent']?.meta?.type;
      return this.template === type && type === 'categories';
    },
    rootHeaderImageUrl () {
      return this.content?.headerImage ? this.content?.headerImage[0]?.url : null;
    },
    headerImageUrl () {
      const headerBannerValue = this.isRootCategory ? this.rootHeaderImageUrl : this.category?.properties?.find((property) => property.name === 'HeaderBanner')?.value;
      return headerBannerValue ? headerBannerValue : this.category?.image?.url;
    },
    headerContent () {
      return {
        headline: this.isRootCategory && this.content?.headerHeadline ? this.content.headerHeadline : this.headline,
        rteText: this.isRootCategory && this.content?.headerDescription ? this.content.headerDescription : this.category?.description,
        link: null,
        image: this.headerImageUrl && !this.isLoading ? [ { Url: this.headerImageUrl } ] : null,
        imageAltText: this.headline,
      }
    },
    longDescription () {
      return this.category?.properties?.find(prop => prop.name === 'LongDescription')?.value;
    },
  },
  methods: {
    getPropertyValue (elm, propertyName) {
      let item = elm.properties.find(x => x.name === propertyName && x.value !== '')
      return item?.value
    }
  }
}
</script>
